/**
 * AI Agent page — localization manifest.
 */
export const agentManifest: readonly string[] = [
  "agent.title",
  "agent.proposals",
  "agent.approved",
  "agent.rejected",
  "agent.executed",
  "agent.pending",
  "agent.approve",
  "agent.reject",
  "agent.execute",
  "agent.confidence",
  "agent.impact",
  "agent.priority",
  // Shared
  "nav.aiAgent",
  "common.loading",
  "common.noData",
  "common.actions",
  "common.status",
  "common.search",
  "common.filter",
] as const;
